import { useRoute } from '@react-navigation/native';
import { useIsFocused } from '@react-navigation/native';
import { Children, cloneElement, useEffect, useRef } from 'react';
import { logElementView } from '@/logging/Logger';
import { useLogParams } from './LogParamsProvider';
export function LogView({ children, elementName, params }) {
    const child = Children.only(children);
    const globalLogParams = useLogParams();
    const route = useRoute();
    const isFocused = useIsFocused();
    const hasLoggedRef = useRef(false);
    useEffect(() => {
        if (!isFocused) {
            hasLoggedRef.current = false;
            return;
        }
        if (!hasLoggedRef.current) {
            logElementView({
                name: elementName,
                currScreenName: route.name,
                extraParams: Object.assign(Object.assign({}, globalLogParams), params),
            });
            hasLoggedRef.current = true;
        }
    }, [isFocused]);
    return cloneElement(child);
}
